module.exports = __webpack_public_path__ + "img/User_input.e149c1f0.gif";